module.exports = __webpack_public_path__ + "static/media/thread-created.91333ff6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/thread-created.svg
// module id = 935
// module chunks = 17